import { useSyncExternalStore } from 'react';

// useSyncExternalStore — каноничный React-way для подписки на matchMedia.
// SSR-safe: getServerSnapshot всегда false.
function subscribe(query: string, callback: () => void): () => void {
  if (typeof window === 'undefined') return () => {};
  const mql = window.matchMedia(query);
  mql.addEventListener('change', callback);
  return () => mql.removeEventListener('change', callback);
}

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (callback) => subscribe(query, callback),
    () => (typeof window !== 'undefined' ? window.matchMedia(query).matches : false),
    () => false,
  );
}

// Tailwind sm breakpoint = 640px → <640px = mobile
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 639px)');
}
